module.exports = __webpack_public_path__ + "img/Group4.9d691504.png";